/**
 * main.js
 *
 * Bootstraps the Vue application, registers plugins, and ensures authentication is initialized before mounting.
 */

import { createApp } from 'vue'
import App from './App.vue'
import { registerPlugins } from '@/plugins'
import { useAuthStore } from './store/auth'
import { useTenantStore } from './store/tenant'

// Create the Vue application instance
const app = createApp(App)

// Register global plugins (Vuetify, i18n, Pinia, Router)
registerPlugins(app)

// Initialize Pinia stores
const authStore = useAuthStore()
const tenantStore = useTenantStore()

/**
 * initializeApp
 *
 * Asynchronously binds the user authentication state and fetches necessary user data before mounting the app.
 */
async function initializeApp() {
  try {
    // Bind the user authentication state
    await authStore.bindUser()

    // If the user is authenticated and tenant configuration is missing, fetch it
    if (authStore.userData && !tenantStore.companyConfig) {
      await tenantStore.getCompanyConfig()
    }

    // Mount the Vue application after successful authentication initialization
    app.mount('#app')
  } catch (error) {
    console.error('Failed to initialize app:', error)
    // Redirect to the login page if authentication fails
    window.location.href = '/login'
  }
}

// Start the application initialization process
initializeApp()
